export class Color
{
    hue: number;
    saturation: number;
    lightness: number;
    
    constructor(hue: number, saturation: number, lightness: number) {
        this.hue = hue;
        this.saturation = saturation;
        this.lightness = lightness;
    }
}